import {Box, LinearProgress} from "@mui/material";
import './styles/task.scss'
import {
    ConversionType,
    ExtraProps,
    ResponseProp,
    TaskStatusType
} from "../../types/taskFlow.types";


interface ChatProps {
    loading?: boolean,
    taskResponse?: ResponseProp,
    content?: string
    status?: TaskStatusType,
    taskId?: number,
    extra?: ExtraProps,
    conversionValue: ConversionType
}

export default function Chat (props: ChatProps) {

    const {loading, taskResponse, content, conversionValue} = props;

    return <Box className="task_manage_box">
        { (taskResponse && 'note' in taskResponse) ? taskResponse.note : content }
        { conversionValue === ConversionType.HISTORY && <Box className="task_manage_sub"><span>{ (taskResponse && 'content' in taskResponse) ? taskResponse.content : '' }</span></Box> }
        { conversionValue === ConversionType.CONVERSING && <LinearProgress style={{marginTop: 6}} /> }
    </Box>
}